import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
const categories = [{
  id: 'all',
  name: 'All'
}, {
  id: 'braids',
  name: 'Braids'
}, {
  id: 'locs',
  name: 'Locs'
}, {
  id: 'twisted',
  name: 'Twisted Hair Styles'
}, {
  id: 'protective',
  name: 'Protective Hair Styles'
}];
const galleryItems = [{
  id: 1,
  title: 'Elegant Cornrows',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/eg5LzjxM23zTxgJaZWtdFS/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(3).jpg'
}, {
  id: 2,
  title: 'Cornrow Braiding',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/eq1mzaoV7yww71UG5f3y6M/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(2).jpg'
}, {
  id: 3,
  title: 'Box Braids with Beads',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/8Wg9wbxDuh49g9nkLKA4TN/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(3).jpg'
}, {
  id: 4,
  title: 'Braided Updo',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/jhnvyNTv6F4CCdtD6AQqF8/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(2).jpg'
}, {
  id: 5,
  title: 'Detailed Cornrows',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/eg5LzjxM23zTxgJaZWtdFS/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(3).jpg'
}, {
  id: 6,
  title: 'Braids with Design',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/eq1mzaoV7yww71UG5f3y6M/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(2).jpg'
}, {
  id: 7,
  title: 'Side Braid Style',
  category: 'twisted',
  image: 'https://cdn.magicpatterns.com/uploads/8Wg9wbxDuh49g9nkLKA4TN/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(3).jpg'
}, {
  id: 8,
  title: 'Micro Braids',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/jhnvyNTv6F4CCdtD6AQqF8/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(2).jpg'
}, {
  id: 9,
  title: 'Long Braids',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/eg5LzjxM23zTxgJaZWtdFS/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(3).jpg'
}, {
  id: 10,
  title: 'Faux Locs',
  category: 'locs',
  image: 'https://cdn.magicpatterns.com/uploads/eq1mzaoV7yww71UG5f3y6M/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(2).jpg'
}, {
  id: 11,
  title: 'Braiding in Progress',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/8Wg9wbxDuh49g9nkLKA4TN/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(3).jpg'
}, {
  id: 12,
  title: 'Locs Styling',
  category: 'locs',
  image: 'https://cdn.magicpatterns.com/uploads/jhnvyNTv6F4CCdtD6AQqF8/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(2).jpg'
}, {
  id: 13,
  title: 'Long Knotless Braids',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/oWB37Cf5isF4iXL9cmjzC1/unnamed_(3).webp'
}, {
  id: 14,
  title: 'Bohemian Curls',
  category: 'twisted',
  image: 'https://cdn.magicpatterns.com/uploads/uZPGDAXUcxv2h2PRxGnT3C/unnamed_(2).webp'
}, {
  id: 15,
  title: 'Curly Braids',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/9io7yx3BmLPZQwjKLXQQc9/unnamed_(1).webp'
}, {
  id: 16,
  title: 'Goddess Curls',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/s6Lf7SojeoCY8cGPB5rJ3J/unnamed.webp'
}];
export function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const filteredItems = activeCategory === 'all' ? galleryItems : galleryItems.filter(item => item.category === activeCategory);
  return <>
      <PageBanner title="Style Gallery" subtitle="A glimpse into the artistry and precision of our master braiders" backgroundImage="https://cdn.magicpatterns.com/uploads/eg5LzjxM23zTxgJaZWtdFS/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(3).jpg" data-id="element-609" />

      <section className="py-16 bg-white" data-id="element-610">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-611">
          {/* Category Filters */}
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-612">
            {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeCategory === cat.id ? 'bg-brand-gold text-white shadow-md' : 'bg-gray-100 text-jet hover:bg-brand-gold hover:text-white'}`} data-id="element-613">
                {cat.name}
              </button>)}
          </div>

          {/* Gallery Grid */}
          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-614">
            <AnimatePresence mode="popLayout" data-id="element-615">
              {filteredItems.map((item, index) => <motion.div key={item.id} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.3,
              delay: index * 0.03
            }} className="relative aspect-[4/5] rounded-2xl overflow-hidden group cursor-pointer" data-id="element-616">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-617" />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-jet/80 via-jet/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-618"></div>

                  {/* Content */}
                  <div className="absolute inset-0 p-5 flex flex-col justify-end translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-619">
                    <div className="w-8 h-1 bg-golden mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-620"></div>
                    <h3 className="text-lg font-heading font-bold text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-150" data-id="element-621">
                      {item.title}
                    </h3>
                    <span className="text-golden/80 text-sm capitalize opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200" data-id="element-622">
                      {item.category === 'twisted' ? 'Twisted Hair Style' : item.category}
                    </span>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>

          {/* Instagram CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-16 text-center" data-id="element-623">
            <p className="text-jet/60 mb-4" data-id="element-624">
              See more of our work on social media
            </p>
            <div className="flex justify-center gap-4" data-id="element-625">
              <a href="https://www.instagram.com/reel/DG0S_dgOMK6/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#F77737] text-white font-medium rounded-full hover:opacity-90 transition-opacity" data-id="element-626">
                Follow on Instagram
              </a>
              <a href="https://www.tiktok.com/@roziiepse1.11" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-jet text-white font-medium rounded-full hover:bg-jet/80 transition-colors" data-id="element-627">
                Follow on TikTok
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}